(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19125],{

/***/ 19125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Benefits; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/shield.tsx


function Shield() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "44",
        fill: "none",
        viewBox: "0 0 44 44",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#DF8D46",
                strokeDasharray: "10 10",
                strokeWidth: "2",
                d: "M1 1H43V43H1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#DF8D46",
                d: "M15.998 28.048c-1.512-1.516-1.798-3.072-1.798-3.072l-.04-10.236L22 12.2l7.84 2.54-.042 10.236s-.286 1.554-1.796 3.07c-1.39 1.398-5.344 3.404-5.962 3.714a2.27 2.27 0 01-.082.04c-.616-.348-4.57-2.356-5.96-3.752z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#DF8D46",
                d: "M17.59 22l3.208 3.43 5.612-6.86L17.59 22z"
            })
        ]
    });
}
/* harmony default export */ var shield = (Shield);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/check.tsx


function Check() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "44",
        fill: "none",
        viewBox: "0 0 44 44",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#DF8D46",
                d: "M31.8 17.422c0 .338-.118.624-.354.86L20.572 29.158a1.17 1.17 0 01-.86.354 1.17 1.17 0 01-.86-.354l-6.298-6.298A1.17 1.17 0 0112.2 22c0-.338.118-.624.354-.86l1.72-1.72a1.17 1.17 0 01.86-.354c.338 0 .624.118.86.354l3.718 3.73 8.296-8.308a1.17 1.17 0 01.86-.354c.338 0 .624.118.86.354l1.72 1.72c.234.236.352.524.352.86z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#DF8D46",
                strokeDasharray: "10 10",
                strokeWidth: "2",
                d: "M1 1H43V43H1z"
            })
        ]
    });
}
/* harmony default export */ var check = (Check);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/arrows.tsx


function Arrows() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "44",
        fill: "none",
        viewBox: "0 0 44 44",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#DF8D46",
                d: "M31.62 12.814l-.434-.434a.61.61 0 00-.866 0l-5.846 5.846v-2.38a.614.614 0 00-.614-.612h-.612a.613.613 0 00-.612.612v4.908c0 .338.276.612.612.612h4.908a.613.613 0 00.612-.612v-.614a.613.613 0 00-.612-.612h-2.38l5.846-5.846a.615.615 0 00-.002-.868zm-10.828 9.782h-4.936a.613.613 0 00-.612.612v.62c0 .338.276.612.612.612h2.4l-5.876 5.874c-.24.24-.24.63 0 .87l.434.434c.24.24.63.24.87 0l5.876-5.874v2.398c0 .338.276.612.614.612h.62a.613.613 0 00.612-.612v-4.936a.612.612 0 00-.614-.61z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#DF8D46",
                strokeDasharray: "10 10",
                strokeWidth: "2",
                d: "M1 1H43V43H1z"
            })
        ]
    });
}
/* harmony default export */ var arrows = (Arrows);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/wifi.tsx


function Wifi() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "44",
        fill: "none",
        viewBox: "0 0 44 44",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#DF8D46",
                d: "M15.788 22.666c1.724-1.696 3.802-2.544 6.234-2.544s4.498.848 6.192 2.544l-1.752 1.794c-1.222-1.224-2.71-1.834-4.462-1.834-1.752 0-3.238.612-4.462 1.836l-1.75-1.796zm3.544 3.588c.722-.722 1.612-1.084 2.668-1.084s1.946.362 2.668 1.084L22 28.922l-2.668-2.668zM12.2 19.122c2.724-2.696 5.998-4.046 9.82-4.046s7.082 1.348 9.78 4.046l-1.794 1.794c-2.224-2.196-4.892-3.294-8.006-3.294s-5.782 1.098-8.006 3.294L12.2 19.122z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#DF8D46",
                strokeDasharray: "10 10",
                strokeWidth: "2",
                d: "M1 1H43V43H1z"
            })
        ]
    });
}
/* harmony default export */ var wifi = (Wifi);

;// CONCATENATED MODULE: ./src/components/contentintelligence/benefits/content.tsx





const content = {
    "intelligent-data-capture": {
        title: "Unlocking the Benefits of Intelligent Data Capture for Your Organization",
        "sub-title": "Intelligent capture empowers organizations to overcome several challenges caused by manual data entry by offering unmatched benefits like:",
        points: [
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrows, {}),
                title: "Efficiency Boost with Reduced Overhead",
                description: "By eliminating the need for manual data entry and processing, intelligent data capture minimizes overhead costs and allows your human resources to focus on more valuable tasks."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(wifi, {}),
                title: "Facilitating Seamless Collaboration for Remote Workers",
                description: "Intelligent capture bridges the gap between remote workers, enabling dynamic interactions without being restricted by shared physical locations and work hours."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(shield, {}),
                title: "Enhanced Security Measures",
                description: "Intelligent capture ensures secure content and document delivery to designated recipients, with strict access control. Robust security protocols are swiftly applied to incoming content, guarding against data loss and security breaches."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(check, {}),
                title: "Streamlined Operations Through Integration",
                description: "Integration capabilities create a harmonious business software ecosystem where your data seamlessly syncs and updates across various platforms and applications. This eliminates the need for redundant data entry and the time wasted on searching for the right application to use."
            }, 
        ]
    },
    integrations: {
        title: "Maximizing the Benefits of ECM Integrations for Your Organization",
        points: [
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrows, {}),
                title: "Centralized Data Source",
                description: "Integrating your ECM system with other business software and applications establishes a centralized repository for all your business content. This ensures everyone operates with current and pertinent data, promoting efficiency and consistency across your organization."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(wifi, {}),
                title: "Enhanced Mobility",
                description: "ECM software integrations empower your mobile workforce to maintain connectivity and productivity. Using their smart devices, they can seamlessly access the ECM system and the relevant content required for their tasks using their smart devices."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(shield, {}),
                title: "Intelligent Insights",
                description: "Integrated data and content analytics provide deeper insights, facilitating informed decision-making processes for your organization."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(check, {}),
                title: "Streamlined Operations",
                description: "Integrations enable the creation of a seamless business software ecosystem, automatically synchronizing and updating your business data across various platforms and applications. This reduces or eliminates redundant data entry and the time wasted searching for the right application, enhancing overall operational efficiency."
            }, 
        ]
    },
    "document-and-records-management": {
        title: "Unlocking the Benefits of Document & Records Management for Your Organization",
        points: [
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrows, {}),
                title: "Effective Record Generation and Growth Control",
                description: "n an increasingly digitalized world, the volume of paperwork remains substantial. Document and records management tools empower your organization to take command of record creation and duplication, effectively managing their growth and reducing the storage space required."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(wifi, {}),
                title: "Streamlined Records Retrieval & Disposal",
                description: "Misplacing records or spending excessive time searching for them can lead to detrimental consequences, including customer loss and wasted billable hours. A well-structured document and records management system simplifies records retrieval and ensures efficient disposal when their lifecycle concludes."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(shield, {}),
                title: "Ensuring Regulatory Compliance",
                description: "Stringent compliance regulations make manual adherence a daunting task, potentially resulting in legal repercussions and hefty fines for non-compliance. An advanced records and document management system effortlessly ensures full compliance, eliminating the risk of regulatory breaches."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(check, {}),
                title: "Enhanced Information Security",
                description: "Unauthorized access to sensitive data can lead to catastrophic consequences and potential theft. A document and records management system safeguards the confidentiality and integrity of your documents and records in accordance with your established rules. User-based roles and access levels restrict unauthorized users from accessing and tampering with critical information, ensuring its protection."
            }, 
        ]
    },
    "process-automation": {
        title: "Key Benefits of Process Automation for Your Organization",
        points: [
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrows, {}),
                title: "Enhanced Efficiency",
                description: "Process automation significantly boosts your organization's efficiency, enabling processes to operate 24/7. Moreover, the system can handle bulk operations swiftly, reducing processing time. This automation results in error-free operations, enhancing overall accuracy."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(wifi, {}),
                title: "Increased Productivity",
                description: "With automated tasks distributed among bots, your employees can redirect their focus to customer-centric activities rather than repetitive tasks. Process automation can be set up to run autonomously, freeing up valuable time for human-centered tasks."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(shield, {}),
                title: "Cost Savings",
                description: "Automating repetitive tasks reduces wasted time and labor costs. The saved wages can be reinvested in other areas of your business, providing a higher return on investment."
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(check, {}),
                title: "Enhanced Customer Satisfaction",
                description: "Satisfied customers are a business's greatest asset. Process automation can significantly enhance the customer experience by expediting responses to queries and streamlining interactions such as order processing. This, in turn, leads to more satisfied and loyal customers."
            }, 
        ]
    }
};
/* harmony default export */ var benefits_content = (content);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/contentintelligence/benefits/styles.module.scss
var styles_module = __webpack_require__(71919);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/contentintelligence/benefits/index.tsx





function Benefits() {
    const { query  } = (0,router.useRouter)();
    const item = benefits_content[query.tool];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (styles_module_default()).benefits,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mb-8",
                children: item?.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: item?.points.map((point, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "flex items-end gap-5 mb-4 font-bold",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "children:w-10",
                                        children: point.icon
                                    }),
                                    " ",
                                    point.title
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: point.description
                            })
                        ]
                    }, index))
            })
        ]
    });
}


/***/ }),

/***/ 71919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","benefits":"styles_benefits__RLath"};

/***/ })

}]);